export const CLOSED_QUESTION = "CLOSED_QUESTION";
export const NUMBER_SLIDER = "NUMBER_SLIDER";
export const DROP_DOWN = "DROP_DOWN";
export const FINISH = "FINISH";
